import { render } from "./ValidateAddressHomeHealth.vue?vue&type=template&id=2e8e4426&ts=true"
import script from "./ValidateAddressHomeHealth.ts?vue&type=script&lang=ts&external"
export * from "./ValidateAddressHomeHealth.ts?vue&type=script&lang=ts&external"

import "./ValidateAddressHomeHealth.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__